module.exports = __webpack_public_path__ + "img/social.b2bf95fe.png";